class DeliveryTime extends HTMLElement {
  constructor() {
    super();
    this.days = Number.parseInt(this.getAttribute('data-days') || '0', 10) || 0;
    this.timerInterval = null;
    this.holidaysWeekends = Array.isArray(window.holidaysWeekends) ? window.holidaysWeekends : [];
    this.init();
  }

  disconnectedCallback() {
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.timerInterval = null;
  }

  init() {
    this.calculateDeliveryTime();
  }

  isHoliday(date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = String(date.getFullYear());
    return this.holidaysWeekends.includes(`${yyyy}-${mm}-${dd}`);
  }

  isDispatchBlockedDate(date) {
    return date.getDay() === 0 || this.isHoliday(date);
  }

  getWeekdayName(date) {
    return new Intl.DateTimeFormat('de-DE', { weekday: 'long' }).format(date);
  }

  calculateDeliveryTime() {
    const timerEl = this.querySelector('.delivery-time__timer');
    const todayTitleEl = this.querySelector('.today-title');
    const tomorrowTitleEl = this.querySelector('.tomorrow-title');
    const dayAfterTomorrowTitleEl = this.querySelector('.day-after-tomorrow-title');
    const nextShipmentEl = this.querySelector('.next-shipment');
    const daysResultEl = this.querySelector('.delivery-time__days-result');

    if (!timerEl || !todayTitleEl || !tomorrowTitleEl || !dayAfterTomorrowTitleEl || !nextShipmentEl || !daysResultEl) return;

    // TESTING: replace the line below to simulate a specific time.
    // Format example: new Date('2026-01-21T12:34:00')  // YYYY-MM-DDTHH:mm:ss (local time)
    const testDate = this.getAttribute('data-test');
    const getNow = () => testDate && testDate !== '' ? new Date(testDate) : new Date();

    const now = getNow();
    const baseDays = Number.parseInt(this.getAttribute('data-days') || '0', 10) || 0;
    let computedDays = baseDays;

    let target;
    const dayOfWeek = now.getDay();
    const cutoff = new Date(now);
    cutoff.setHours(13, 0, 0, 0);

    const isBeforeCutoff = now.getTime() < cutoff.getTime();
    let dispatchOffset = (!this.isDispatchBlockedDate(now) && isBeforeCutoff) ? 0 : 1;

    const dispatchDate = new Date(now);
    dispatchDate.setHours(12, 0, 0, 0);
    dispatchDate.setDate(dispatchDate.getDate() + dispatchOffset);

    if (dispatchOffset > 0) {
      while (this.isDispatchBlockedDate(dispatchDate)) {
        dispatchOffset += 1;
        dispatchDate.setDate(dispatchDate.getDate() + 1);
      }
    }

    target = dispatchOffset === 0
      ? cutoff
      : (() => {
        const t = new Date(now);
        t.setHours(24, 0, 0, 0);
        return t;
      })();

    todayTitleEl.classList.toggle('active', dispatchOffset === 0);
    tomorrowTitleEl.classList.toggle('active', dispatchOffset === 1);
    dayAfterTomorrowTitleEl.classList.toggle('active', dispatchOffset === 2);
    nextShipmentEl.classList.toggle('active', dispatchOffset > 2);

    if (dispatchOffset > 2) {
      const baseNextShipmentText = nextShipmentEl.dataset.baseText || nextShipmentEl.textContent.trim();
      nextShipmentEl.dataset.baseText = baseNextShipmentText;
      nextShipmentEl.textContent = `${baseNextShipmentText} ${this.getWeekdayName(dispatchDate)}`;
    }

    computedDays += dispatchOffset;

    if (dayOfWeek === 5) {
      const fridayCutoff = new Date(now);
      fridayCutoff.setHours(13, 0, 0, 0);
      if (now.getTime() < fridayCutoff.getTime()) {
        computedDays += 1;
      }
    }

    this.days = computedDays;

    const deliveryDate = new Date(now);
    deliveryDate.setHours(12, 0, 0, 0);
    deliveryDate.setDate(deliveryDate.getDate() + this.days);

    while (deliveryDate.getDay() === 0 || this.isHoliday(deliveryDate)) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      this.days += 1;
    }

    const dd = String(deliveryDate.getDate()).padStart(2, '0');
    const mm = String(deliveryDate.getMonth() + 1).padStart(2, '0');
    const yyyy = String(deliveryDate.getFullYear());
    daysResultEl.textContent = `${dd}.${mm}.${yyyy}`;

    const refresh = () => {
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval = null;
      setTimeout(() => this.calculateDeliveryTime(), 1000);
    };

    const renderTimer = () => {
      const diffMs = target.getTime() - getNow().getTime();
      const totalMinutes = Math.max(0, Math.ceil(diffMs / 60000));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      timerEl.textContent = `${String(hours).padStart(2, '0')}:${String(
        minutes
      ).padStart(2, '0')}`;

      if (totalMinutes <= 0) {
        refresh();
      }
    };

    renderTimer();
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.timerInterval = setInterval(renderTimer, 1000);
    this.classList.add('active');
  }

}

customElements.define('delivery-time', DeliveryTime);